import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { RiskSelectItem } from 'src/app/data/models/IncidentReport/incident-report.model';
import { RiskLevel } from 'src/app/data/models/sources/source';

@Injectable({
  providedIn: 'root'
})
export class RiskService {
  constructor(private http: HttpClient) { }

  GetAllRisk(): Observable<RiskSelectItem[]> {
    return this.http.get<RiskSelectItem[]>('/Risk/GetAllRisks/');
  }

  getRisks(): Observable<RiskLevel[]> {
    return this.http.get<RiskLevel[]>('/Risk');
  }
}

